<template>
  <detail-component
    class="detail-panel-container"
  >
    <template #content>
      <div class="content">
        <div class="panel-right">
          <jakartowns-panel />

          <div :class="'detail-panel__assets'">
            <div v-if="selectedAsset" :class="'detail-panel__asset'">
              <h2>Asset Details</h2>
              <div class="detail-panel__asset__attributes" v-for="(value, key) in selectedAsset.properties" :key="key">
                <div :class="'detail-panel__asset__attribute'">
                  <p :class="'detail-panel__asset__attribute__name'">{{ key }}:</p>
                  <div class="property-content-wrapper">
                    <p
                      id="property-content"
                      :class="'detail-panel__asset__attribute__value'">{{ value }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </template>
  </detail-component>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import DetailComponent from '@/components/detail-panel/detail-component.vue'
import jakartownsPanel from './jakartowns-panel.vue'
import useDetailPanelStore from '@/stores/detailPanel'
import useJakartownsApi from '@/composables/useJakartownsApi'
const initJakartowns = useJakartownsApi()

const detailPanelStore = useDetailPanelStore()
const { selectedAsset, isPanelDisplayed } = storeToRefs(detailPanelStore)

watch(selectedAsset, (newAsset) => {
  if (newAsset) {
    initJakartowns()
  }
})

onMounted(() => {
  if (isPanelDisplayed.value) {
    document.querySelector('.detail-panel-container').style.display = 'block'
  }
})
</script>

<style lang="scss" scoped>
.detail-panel-container {
  border-radius: 12px;
  pointer-events: none;
  & > * {
    pointer-events: auto;
  }
  .content {
    pointer-events: none;
    & > * {
      pointer-events: auto;
    }
    .panel-left {
      pointer-events: none;
      & > * {
        pointer-events: auto;
      }
    }
  }
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: white;
}

.panel-right {
  width: 600px;
  max-width: 33vw;
  height: 100%;
  border-radius: 12px;
  box-shadow: var(--panel-shadow);
  background: var(--panel-background);
  backdrop-filter: var(--panel-backdrop);
  display: flex;
  flex-direction: column;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.detail-panel__assets {
  height: 100%;
  width: 100%;

  overflow-y: auto;
}

.detail-panel__asset {
  padding-bottom: 5px;

  transition: 250ms ease-in-out;
}

.detail-panel__asset h2 {
  padding-left: 10px;
  color: var(--primary);
  font-family: 'Poppins';
}

.detail-panel__asset__attributes {
  max-height: 0px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  overflow: hidden;

  transition: 500ms ease-in-out;
    max-height: 5000px;
}

.detail-panel__asset__attribute {
  padding: 0px 20px 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.detail-panel__asset__attribute__name {
  margin: 0;

  font-family: var(--font-family);
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
  color: var(--black);
}

.detail-panel__asset__attribute__value {
  margin: 0;

  font-family: var(--font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: var(--primary);
}

.property-content-wrapper {
  display: inline-block;
  position: relative;
}

#property-content {
  display: inline;
}

@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
</style>
